import StickySidebar from "./../../../node_modules/sticky-sidebar/src/sticky-sidebar.js";

const StickyBar = () => {
  let sidebar = null;

  const initSidebar = () => {
    if (!document.querySelector('#sidebar')) {
      return;
    }

    const main__entry = document.getElementById('main__entry');
    const sidebar__inner = document.getElementById('sidebar__inner');

    if (main__entry && sidebar__inner) {
      const mainHeight = main__entry.offsetHeight;
      const sidebarHeight = sidebar__inner.offsetHeight;

      if (mainHeight > sidebarHeight && window.innerWidth > 991) {
        sidebar = new StickySidebar('#sidebar', {
          topSpacing: 180,
          bottomSpacing: 30,
          containerSelector: '#main__content',
          innerWrapperSelector: '#sidebar__inner'
        });
      } else if (sidebar) {
        sidebar.destroy();
        sidebar = null;
      }
    }
  };

  // Initial setup
  initSidebar();

  // Re-initialize on window resize
  window.addEventListener('resize', initSidebar);

  // Use MutationObserver to watch for changes in the DOM
  const observer = new MutationObserver(() => {
    // Debounce the initSidebar call to avoid excessive recalculations
    if (sidebar) {
      sidebar.updateSticky();
    }
    setTimeout(initSidebar, 100);
  });

  const config = { childList: true, subtree: true };
  observer.observe(document.getElementById('main__entry'), config);

  // Clean up function to remove event listeners and disconnect observer
  return () => {
    window.removeEventListener('resize', initSidebar);
    observer.disconnect();
    if (sidebar) {
      sidebar.destroy();
    }
  };
};

export default StickyBar;